// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/ShadersInclude/clipPlaneFragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'clipPlaneFragment';
const shader = `#ifdef CLIPPLANE
if (fClipDistance > 0.0 && fInsideMesh > 0.5)
{
discard;
}
#endif
#ifdef CLIPPLANE2
if (fClipDistance2 > 0.0 && fInsideMesh2 > 0.5)
{
discard;
}
#endif
#ifdef CLIPPLANE3
if (fClipDistance3 > 0.0 && fInsideMesh3 > 0.5)
{
discard;
}
#endif
#ifdef CLIPPLANE4
if (fClipDistance4 > 0.0 && fInsideMesh4 > 0.5)
{
discard;
}
#endif
#ifdef CLIPPLANE5
if (fClipDistance5 > 0.0 && fInsideMesh5 > 0.5)
{
discard;
}
#endif
#ifdef CLIPPLANE6
if (fClipDistance6 > 0.0 && fInsideMesh6 > 0.5)
{
discard;
}
#endif
`;
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const clipPlaneFragment = { name, shader };
//# sourceMappingURL=clipPlaneFragment.js.map